export enum eApplications {
    PCH,
    PCHServiciosFinancieros,
    PCHInversionista,
    PCHCliente
}